import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { GlobeOutline, LockClosedOutline, UserGroupOutline } from '@bonusly/design-system';

import { Privacy } from '../types';

export const usePrivacyOptions = () => {
	const { t } = useTranslation('action_input');

	return useMemo(() => {
		return [
			{
				description: t('privacy.public_description'),
				icon: <GlobeOutline />,
				label: t('privacy.public'),
				value: Privacy.Public,
			},
			{
				description: t('privacy.team_description'),
				icon: <UserGroupOutline />,
				label: t('privacy.team'),
				value: Privacy.Team,
			},
			{
				description: t('privacy.private_description'),
				icon: <LockClosedOutline />,
				label: t('privacy.private'),
				value: Privacy.Private,
			},
		];
	}, [t]);
};
